import React, { useState } from "react";
import { Button, Pagination } from "../../shared";
import { useGetPrices } from "../../hooks/price";
import { UpdatePricesModal } from "../../features";
import PricesTable from "./components/PricesTable";
import "./PricesPage.scss";
import { useNavigate } from "react-router-dom";

type PricesPageProps = {};

const PricesPage: React.FC<PricesPageProps> = () => {
  const [page, setPage] = useState(1);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const { data, loading, refetch } = useGetPrices(page);
  const navigate = useNavigate();

  const handleUpdateSuccess = () => {
    // Refresh the data after successful update
    refetch();
  };

  const handleExpandRecord = (recordId: string) => {
    navigate(`/dashboard/prices/${recordId}`);
  };

  if (loading) {
    return <div className="loading">Ładowanie...</div>;
  }

  return (
    <>
      <div className="prices-page">
        <div className="prices-page__header">
          <h1>Aktualizacja cen</h1>
          <Button
            label="Aktualizuj ceny"
            onClick={() => setIsUpdateModalOpen(true)}
            styleType="primary"
          />
        </div>

        <PricesTable
          data={data?.data || []}
          showExpandedView={false}
          onExpandRecord={handleExpandRecord}
        />

        {data?.meta && data?.meta?.lastPage > 1 && (
          <Pagination
            totalPages={data?.meta?.lastPage}
            currentPage={data?.meta?.currentPage || page}
            onPageChange={(newPage: number) => setPage(newPage)}
          />
        )}
      </div>

      <UpdatePricesModal
        isOpen={isUpdateModalOpen}
        onClose={() => setIsUpdateModalOpen(false)}
        onSuccess={handleUpdateSuccess}
      />
    </>
  );
};

export default PricesPage;
